export default "> Estimated Time: ~3 mins\n\nTo generate the documentation of all the flows of a respository.\n";